import { apiRequest } from '../client';
import type { PageResponse } from '../types';

/** Mirrors backend in.voltpassport.productmodel.api.BatteryChemistry */
export type BatteryChemistry = 'LFP' | 'NMC' | 'NCA' | 'LTO' | 'LMO' | 'OTHER';

/** Mirrors backend BatteryModelStatus */
export type BatteryModelStatus = 'DRAFT' | 'ACTIVE' | 'OBSOLETE';

export interface BatteryModelView {
  id: string;
  code: string;
  name: string;
  chemistry: BatteryChemistry;
  nominalVoltage: number;
  capacityAh: number;
  status: BatteryModelStatus;
  createdAt: string;
}

export interface BatteryModelSummary {
  id: string;
  code: string;
  name: string;
  status: BatteryModelStatus;
}

export interface CreateBatteryModelRequest {
  code: string;
  name: string;
  chemistry: BatteryChemistry;
  nominalVoltage: number;
  capacityAh: number;
}

export const batteryModelsApi = {
  list: (page = 0, size = 20) =>
    apiRequest<PageResponse<BatteryModelView>>(
      `/api/product-models?page=${page}&size=${size}`
    ),

  summaries: (page = 0, size = 20) =>
    apiRequest<PageResponse<BatteryModelSummary>>(
      `/api/product-models/summaries?page=${page}&size=${size}`
    ),

  get: (id: string) => apiRequest<BatteryModelView>(`/api/product-models/${id}`),

  create: (request: CreateBatteryModelRequest) =>
    apiRequest<BatteryModelView>('/api/product-models', {
      method: 'POST',
      body: request
    })
};
